import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { countDifferences } from './permissions-widget';

import { store } from '@/atoms';

export const TEMP_clearPermissionsStorage = () => {
  localStorage.removeItem('perms-widget.permissions.v2');
  localStorage.removeItem('perms-widget.permissions-applied-to-token.v2');
  localStorage.removeItem('perms-widget.permissions-on-actual-token.v2');
  localStorage.removeItem('perms-widget.initialized.v2');
};

/** Possible permissions to modify. */
const possiblePermissions = [
  'LEADER',
  'TRAINER',
  'ADMIN',
  'LICENSEESTAFF',
  'STAKEHOLDER',
  'SEARCH_ALT_PROCEDURE',
  'LOGIN',
  'OPERATOR',
];

const permissions = possiblePermissions.reduce<Record<string, boolean>>(
  (acc, permission) => ({ ...acc, [permission]: false }),
  {},
);

export const openAtom = atom(false);
export const permissionsAtom = atomWithStorage(
  'perms-widget.permissions.v2',
  permissions,
  undefined,
  {
    getOnInit: true,
  },
);
export const permissionsAppliedToTokenAtom = atomWithStorage(
  'perms-widget.permissions-applied-to-token.v2',
  permissions,
  undefined,
  {
    getOnInit: true,
  },
);
export const permissionsOnActualTokenAtom = atomWithStorage(
  'perms-widget.permissions-on-actual-token.v2',
  [] as string[],
  undefined,
  {
    getOnInit: true,
  },
);
export const permissionsWidgetInitializedAtom = atomWithStorage(
  'perms-widget.initialized.v2',
  false,
  undefined,
  {
    getOnInit: true,
  },
);
export const tokenHasChangesAtom = atom(get => {
  const permissions = get(permissionsAtom);
  const tokenPermissions = get(permissionsOnActualTokenAtom);
  const appliedPerms = get(permissionsAppliedToTokenAtom);
  const basePerms = Object.keys(permissions).reduce<Record<string, boolean>>(
    (acc, permission) => ({
      ...acc,
      [permission]: tokenPermissions.includes(permission),
    }),
    {},
  );
  const diff = countDifferences(basePerms, appliedPerms);
  return diff !== 0;
});

export const togglePermission = (permission: string) => {
  const permissions = { ...store.get(permissionsAtom) };
  permissions[permission] = !permissions[permission];
  store.set(permissionsAtom, permissions);
};

export const setSomePermissions = (permissions: Record<string, boolean>) => {
  const newPermissions = { ...store.get(permissionsAtom) };
  Object.entries(permissions).forEach(([permission, toggle]) => {
    newPermissions[permission] = toggle;
  });
  store.set(permissionsAtom, newPermissions);
};
